import { useEffect, useState } from "react";
import { ChordShapeHelper } from "../../../Comps/ChordShapeHelper/ChordShapeHelper";
import { Helper } from "../../../Comps/HelperSelector/HelperSelector";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { FlexRowThree, FlexRowTwo } from "../../../Layouts/FlexRows";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { useSetOpenHelpers } from "../../CourseStore";
import { ChordBuilderExercise } from "../../Exercises/ChordBuilderExercise/ChordBuilderExercise";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import './SubstituteChords.scss'
import { NotePlayer } from "../../../Sound/NotePlayer";
import { useNotePlayer } from "../../../Sound/SoundStore";
import { Chords } from "../../../Util/Music/Chords";
import { DotNav } from "../../../Comps/DotNav/DotNav";
import { HxChildMap } from "../../../Comps/HxMap/HxChildMap";

export function SubstituteChords(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}]
    return  <div>
                <h1>Substitute Chords</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}
export function Lesson(){
    const [screenIndex, setScreenIndex] = useState(0)
    const ScreenComp = () => {
        const comp:JSX.Element = (screenIndex === 0) ? <SideBySide/> : <ChordsWithSubs/>
        return comp
    }
    const updateScreenIndex = (scrIndex:number) => {
        setScreenIndex(scrIndex)
    }
    return(
           <OutlineBox title={'Substitute Chords : Chords That Share Two Notes'} width={700}>
                <div className={'substitute-chords Lesson'} style={{marginTop:35, marginBottom:35}}>
                    <ScreenComp/>
                    <DotNav length={2} selectedIndex={screenIndex} onClick={updateScreenIndex}/>
                </div>
            </OutlineBox>



    )
}
export function SideBySide(){
   return( 
            <div style={{margin:'auto', width:700}}>
                <FlexRowTwo columnOneFlex={1} columnTwoFlex={1} width={700}>
                    <HxChildMap height={250} width={250} tonic={Music.C} radius={90} hilitedNotes={[]}/>
                    <HxChildMap height={250} width={250} tonic={Music.C} radius={90} hilitedNotes={[]}/>
                </FlexRowTwo>
            </div>
        )
}
export function ChordsWithSubs(){
    const tonic:number = Music.C
    const notePlayer:NotePlayer = useNotePlayer()
    useSetOpenHelpers([Helper.HEX_PATTERN, Helper.CHORD_TYPE, Helper.CHORD_SHAPES])
    const [selectedIndex, setSelectedIndex] = useState(0)
    const getSubA = () => {
        return ((selectedIndex + 2) % 7)
    }
    const getSubB = () => {
        const index:number = ((selectedIndex - 2 + 7) % 7)
        return index
    }
    const getMessage = () => {
        return `The ${selectedIndex + 1} Chord Substitutes: The ${getSubA() + 1} Chord (aka the Mediant) and the ${getSubB() + 1} Chord (aka the Submediant)`
    }
    const onNoteSelect = (noteIndex:number) => {
        setSelectedIndex(noteIndex)
    }
    const onTitleClick = (index:number) => {
        const chordNotes:number[] = Chords.GetChordNoteTonics(tonic, index)
        notePlayer.playChord(chordNotes, true)
    }
    const radius:number = 85
    useEffect(()=>{notePlayer.reset()},[])
    return(
            <div style={{width:900, margin:'auto'}}>
                <FlexRowThree columnOneFlex={1} columnTwoFlex={1} columnThreeFlex={1}>
                    <ChordShapeHelper onTitleClick={onTitleClick} offset={selectedIndex} onNoteClick={onNoteSelect} hidePositions={false} hideShape={true} showCaption={true} radius={radius} key={0}/>
                    <ChordShapeHelper onTitleClick={onTitleClick} offset={getSubA()} hidePositions={true} hideShape={true} showCaption={true} radius={radius} key={1}/>
                    <ChordShapeHelper onTitleClick={onTitleClick} offset={getSubB()} hidePositions={true} hideShape={true} showCaption={true} radius={radius} key={1}/>
                </FlexRowThree>
                <h4>{getMessage()}</h4>
                <div style={{textAlign:'left'}}>
                    <ul style={{fontSize:18, marginTop:10}}>
                        <li>
                            The Mediant (2 positions forward) and the Submediant (2 positions back) are always the substitute chords.
                        </li>
                        <li>To create the Mediant, move the root note of the original chord back one position.</li>
                        <li>To create the Submediant, move the 5th note forward one position.</li>
                    </ul>
                </div>
            </div>
    )
}

export function Exercises(){
    useSetOpenHelpers([Helper.CHORD_TYPE, Helper.CHORD_SHAPES])
    return  <ChordBuilderExercise/>
}
export function Resources(){
    return <div>Chord Resources body</div>
}